module.exports = __webpack_public_path__ + "img/program-qrcode.ca792dfb.png";